import axios from 'axios';
import criarToast from './ToastsHandler';
import { recuperarCookie, removerCookie } from './CookiesHandler';

const HttpClientSAIP = axios.create({
  baseURL: process.env.VUE_APP_SAIP_API,
  headers: {
    'Content-Type': 'application/json',
    'Accept': '*/*'
  },
});

// Add a request interceptor to include authorization headers if not logging in
HttpClientSAIP.interceptors.request.use(
  (request) => {
    if (!request.url.endsWith('login-rpa')) {
      request.headers.common['Authorization'] = `Bearer ${recuperarCookie('modos-token')}`;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle success messages and errors
HttpClientSAIP.interceptors.response.use(
  (response) => {
    if (response.config.method !== 'get' && response.data.message?.success) {
      response.data.message.success.forEach((message) => {
        criarToast({
          tipo: 'success',
          mensagem: message,
        });
      });
    }
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      await removerCookie('modos-token');
      return Promise.reject(error);
    }

    if (error.response?.data) {
      let dataErrors = error.response.data.message?.errors;

      if (dataErrors) {
        mostrarMensagensErro(dataErrors);
      } else {
        // Handle non-standard error responses
        dataErrors = error.response.data.mensagem;
        if (typeof dataErrors != 'undefined') {
          dataErrors.forEach((msg) => {
            criarToast({
              tipo: 'error',
              mensagem: msg,
            });
          });
        } else {
          // Handle text error responses safely
          try {
            const responseData = await error.response.data.text();
            dataErrors = JSON.parse(responseData).message.errors[0];
          } catch (e) {
            dataErrors = error.response.data;
          }

          if (typeof dataErrors == 'string') {
            criarToast({
              tipo: 'error',
              mensagem: dataErrors,
            });
          } else {
            Object.keys(dataErrors).forEach((key) => {
              criarToast({
                tipo: 'error',
                mensagem: dataErrors[key][0],
              });
            });
          }
        }
      }
    }

    if (error.response?.status === 500) {
      criarToast({
        tipo: 'error',
        mensagem:
          'Houve um erro com o servidor, tente novamente e se o erro persistir, contate o suporte.',
      });
    }

    return Promise.reject(error);
  }
);

function mostrarMensagensErro(dataErrors) {
  dataErrors.forEach((err) => {
    if (typeof err === 'string') {
      criarToast({
        tipo: 'error',
        mensagem: err,
      });
    } else {
      Object.keys(err).forEach((key) => {
        err[key].forEach((message) => {
          criarToast({
            tipo: 'error',
            mensagem: message,
          });
        });
      });
    }
  });
}

export default HttpClientSAIP;
